.form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  max-width: 42rem;
}

/* F-UIX-022: the sections of a structured brief, one field each, under the brief's name. */
.group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-self: stretch;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  font-weight: 600;
  color: var(--text);
}

.hint {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-muted);
}

.error {
  margin: 0;
  font-size: 0.875rem;
  color: var(--danger-text);
}
